
import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'dashboard'
})
export default class extends Vue {
  private clear () {
    console.log(localStorage)
    localStorage.clear()
    this.$message('清空缓存测试数据成功')
  }
}
